export default "__VITE_ASSET__CvyCXpjs__"